eyebrow: "Currently Building"
headline: "Real problems.<br/><em>Real domains. Real builds.</em>"
lead: "Every project below started with a domain expert identifying a problem that existing tools don't solve. We're building the infrastructure that fixes it."

flagship:
  - sector: "Legal Tech"
    sectorClass: "fcs-legal"
    icon: "⚖️"
    title: "eClarify"
    tagline: '"Legal Document Intelligence for Indian Law Firms"'
    pain: "Law firms spend 8–14 hours per complex petition on manual tasks — printing, stamping, bookmarking, and verifying appendices. A senior paralegal's time. Every single filing."
    description: "eClarify automates the entire document preparation pipeline. Drop in a raw PDF and get back a fully searchable, bookmarked, True Copy-stamped filing-ready document — in minutes, not hours."
    features:
      - "High-accuracy OCR with layout preservation"
      - "Automatic bookmark extraction from document index"
      - "True Copy stamping with verification chain"
      - "Appendix completeness checking"
      - "On-premise deployment for data-sensitive firms"
    status: "Active Development"
    cardClass: "fc-legal"

  - sector: "HR Tech"
    sectorClass: "fcs-hr"
    icon: "👥"
    title: "Vidhik"
    tagline: '"Contractor Management for the Gig Economy"'
    pain: "Companies managing 20+ contractors run on spreadsheets, WhatsApp chains, and manual compliance chasing. Onboarding takes days. Status tracking is a full-time job. Compliance audits are a nightmare."
    description: "Vidhik is an end-to-end HRMS built specifically for contract-heavy workforces — with AI-driven onboarding flows, real-time compliance tracking, and automated status management across jurisdictions."
    features:
      - "AI-driven onboarding with document collection"
      - "Real-time contractor status and availability tracking"
      - "Automated compliance checks across jurisdictions"
      - "Integrated invoice and payment workflow"
      - "Audit-ready reporting at any point"
    status: "Active Development"
    cardClass: "fc-hr"

initiatives:
  - icon: "🔐"
    title: "AI Security & Vulnerability SaaS"
    desc: "Continuous vulnerability detection with native CI/CD pipeline integration. Shifts security from periodic audit to always-on intelligence."
    tag: "Exploring"
    tagVariant: "blue"
  - icon: "🔄"
    title: "N8N Workflow Automation"
    desc: "End-to-end workflow orchestration using N8N — connecting your tools, eliminating manual handoffs, and building reliable automated pipelines."
    tag: "Building"
    tagVariant: "green"
  - icon: "🧩"
    title: "Composio Integrations"
    desc: "AI agent integrations via Composio — connecting LLMs to your existing SaaS tools with reliable, structured action execution."
    tag: "Active"
    tagVariant: "green"
  - icon: "🤖"
    title: "Multi-Agent Pipelines"
    desc: "Orchestrated AI agent systems for complex, multi-step business workflows. Research, decision, and execution agents working in sequence."
    tag: "Exploring"
    tagVariant: "blue"
  - icon: "💬"
    title: "Context-Aware QA Systems"
    desc: "Intelligent knowledge bases that transform static FAQs into dynamic, context-sensitive support interfaces. Pilot live for creative agencies."
    tag: "Pilot Running"
    tagVariant: "caramel"
  - icon: "🔌"
    title: "API & Systems Integration"
    desc: "Custom integration work connecting AI outputs to your existing ERP, CRM, or workflow tools. We handle the messy plumbing."
    tag: "Available Now"
    tagVariant: "green"
  - icon: "📄"
    title: "Document Intelligence Platform"
    desc: "Generalised OCR and document understanding layer — extractable as a standalone API for any document-heavy workflow beyond legal."
    tag: "Exploring"
    tagVariant: "blue"
